//* 全局变量
import type { UiTypes } from "@various/constants";
//* 边界处理函数
import { relativeContainerBody, type RelativeContainerBodyOption } from "../dispose/boundary";
//* 滚动条尺寸计算函数
import { scrollbar } from "../dispose/size";

//* 获取ID选择器选择的盒子, 若无则返回null
export const use = (selector: HTMLElement | string) => {
    //* 检测selector类型, string为容器ID, HTMLElement为HTML节点
    if (typeof selector == "string") {
        return document.querySelector(`#${selector}`);
    } else {
        return selector;
    }
};

//* 为指定盒子添加node, 若找不到该盒子则在body下新建一个
export const append = (selector: HTMLElement | string, el: Node) => {
    //* 初始化数据
    let container: HTMLElement | Element | null = use(selector);
    //* 检测是否存在该节点, 不存在则在body中插入节点
    if (!container) {
        container = document.createElement("div");
        container.id = selector as string;
        document.body.appendChild(container);
    } else {
        //* 检测node节点是否已存在
        for (let i = 0, l = container?.children?.length || 0; i < l; i++) {
            if (el && container?.children[i] == el) return;
        }
    }

    container.appendChild(el);
};

//* 为指定盒子删除node
export const remove = (selector: HTMLElement | string, el: Node) => {
    //* 初始化数据
    const container: HTMLElement | Element | null = use(selector);
    //* 检测该盒子子元素是否存在node, 存在则删除
    for (let i = 0, l = container?.children?.length || 0; i < l; i++) {
        if (el && container?.children[i] == el) {
            container.removeChild(el);
            break;
        }
    }
};

//* 检测当前节点是否在给定节点之中
export const includes = (current: HTMLElement | null, container: HTMLElement): boolean => {
    if (!current) return false;
    else if (current == container) {
        return true;
    } else {
        return includes(current.parentElement, container);
    }
};

//* 将菜单插入到body中
export const menus = {
    open: (options: {
        container: HTMLElement;
        content: HTMLElement;
        option: RelativeContainerBodyOption;
        widthExtra?: number | "auto" | "content";
        handler?: () => void;
    }) => {
        //* 将内容添加到视图容器中
        append(document.body, options.content);
        //* 注册观察者
        const observer = new ResizeObserver(() => {
            //* 数据初始化
            const data = { container: options.container, view: options.content };
            const config = options.option;
            //* 设置窗口宽度
            const width = options.container?.offsetWidth || 0;
            const widthExtra = Number(options.widthExtra);
            if (options.widthExtra == "auto" || widthExtra < width) config.width = { min: width, max: 0 };
            else if (options.widthExtra == "content") config.width = width;
            else if (options.widthExtra && options.widthExtra > 0) {
                config.width = { min: width, max: widthExtra };
            }

            //* 边界处理
            relativeContainerBody(data, config);
            //* 额外回调
            options.handler?.();
        });

        //* 将内容添加到视图容器中
        observer.observe(document.body);
        observer.observe(options.container);
        //* 返回观察者
        return observer;
    },
};

//* 移除body滚动条
export const scrollbarHidden = (option?: { unit?: UiTypes.styleUnit }) => {
    const config = {
        scrollbar: scrollbar(),
        overflow: document.body.style.overflow,
        spacing: { x: document.body.style.paddingRight, y: document.body.style.paddingBottom },
        unit: option?.unit || "px",
    };

    //* 隐藏X轴滚动条
    if (config.scrollbar.x) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = config.spacing.x
            ? `calc(${config.spacing.x}+${config.scrollbar.x}${config.unit})`
            : `${config.scrollbar.x}${config.unit}`;
    }

    //* 隐藏Y轴滚动条
    if (config.scrollbar.y) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingBottom = config.spacing.y
            ? `calc(${config.spacing.y}+${config.scrollbar.y}${config.unit})`
            : `${config.scrollbar.y}${config.unit}`;
    }

    return config;
};
